export default __webpack_public_path__ + "static/media/allergi-logo.79aacf9d.png";